import type { User } from '../types';

export const mockUser: User = {
  id: 'user-123',
  discordId: 'discord-abc123',
  discordUsername: 'trader_john',
  role: 'Inner Circle',
  joinedAt: '2026-03-15',
  accountSize: 25000,
  currentTier: 'Shield',
  currentStrategy: 'TCL',
  currentFirmId: 'apex',
  currentPlanId: 'intraday-trail',
  stats: {
    totalTrades: 87,
    winCount: 70,
    avgWinner: 1.2,
    avgLoser: 0.95,
    accountDrawdown: 1500,
    winRate: 0.8045,
    expectancy: 0.78,
  },
  traderStage: null,
  monthsTrading: 6,
  challengeStatus: null,
};
